(() => {
  const SELECTOR = '.template-product .f-product-single__info--sticky .f-product-single__blocks';
  const EDGE_GAP = 10;

  const getHeaderHeight = () => {
    const value = getComputedStyle(document.documentElement).getPropertyValue('--f-header-height');
    return Number.parseFloat(value) || 0;
  };

  const updateStickyState = (element) => {
    const headerHeight = getHeaderHeight();
    const availableHeight = window.innerHeight - headerHeight - EDGE_GAP * 2;
    const elementHeight = element.getBoundingClientRect().height;
    const top = elementHeight > availableHeight
      ? window.innerHeight - elementHeight - EDGE_GAP
      : headerHeight + EDGE_GAP;

    element.style.setProperty('--colon-product-sticky-top', `${Math.round(top)}px`);
  };

  const init = () => {
    const elements = [...document.querySelectorAll(SELECTOR)];
    if (!elements.length) return;

    let frame;
    const updateAll = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => elements.forEach(updateStickyState));
    };

    updateAll();
    window.addEventListener('resize', updateAll, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateAll);
      elements.forEach((element) => observer.observe(element));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
